import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { ObjectTypeFromIds } from 'customer-data-objects/constants/ObjectTypeIds';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"property-translator/propertyTranslator"' ... Remove this comment to see the full error message
import { stageLabelTranslator } from 'property-translator/propertyTranslator';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { useIsEmbeddedContext } from 'customer-data-sidebar/universal/context/IsEmbeddedContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import FieldLevelPermissionTooltip from 'customer-data-sidebar/fieldLevelPermissions/FieldLevelPermissionTooltip';
import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { NOT_SPECIFIED } from 'customer-data-objects/property/AccessLevel';
import emptyFunction from 'react-utils/emptyFunction';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Button } from 'foundations-components/transitional/components/Button';
import { gate } from 'hub-http/gates';
import { useAssociatedObjectsCardContext } from '../context/AssociatedObjectsCardContext';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "AutosaveChickletStageSelect__StyledSpan",
  componentId: "sc-1ub6i4c-0"
})(["display:flex !important;"]);

// exporting unmemoized version for testing
export const AutosaveChickletStageSelect = ({
  pipeline: {
    pipelineId
  },
  currentStage,
  fieldLevelAccess,
  objectTypeId,
  objectId,
  stagePropertyDefinition,
  readOnly,
  getSavedValue = emptyFunction.thatReturns(undefined),
  getDraftValue = emptyFunction.thatReturns(undefined)
}) => {
  const [value, setValue] = useState(currentStage === null || currentStage === void 0 ? void 0 : currentStage.stageId);
  useEffect(() => {
    setValue(currentStage === null || currentStage === void 0 ? void 0 : currentStage.stageId);
  }, [currentStage]);
  const isEmbedded = useIsEmbeddedContext();
  const handleChange = useCallback(propertyUpdates => {
    const updatedValue = stagePropertyDefinition !== null && stagePropertyDefinition !== void 0 && stagePropertyDefinition.name ? propertyUpdates[stagePropertyDefinition.name] : undefined;
    setValue(updatedValue);
    CrmLogger.log('sidebar-interaction', {
      type: normalizeTypeId(objectTypeId),
      action: 'clicked hyperlinked action from card',
      subAction: 'deal stage'
    });
  }, [objectTypeId, stagePropertyDefinition]);
  const {
    isUngated
  } = useAssociatedObjectsCardContext();
  const hasDisplayOptimizedGate = isUngated(gate('CRM:Properties:FormControlDisplayOptimized'));
  const buttonUse = hasDisplayOptimizedGate ? 'link' : 'unstyled';
  const isDisabled = fieldLevelAccess !== NOT_SPECIFIED;
  const inputProps = useMemo(() => ({
    anchorType: 'button',
    buttonUse,
    menuWidth: 250,
    'data-selenium-test': 'base-chicklet-select',
    'data-test-id': 'base-chicklet-select',
    ButtonContent: ({
      buttonText
    }) => {
      return /*#__PURE__*/_jsx(Button, {
        use: "link",
        disabled: isDisabled,
        children: /*#__PURE__*/_jsx(TruncateString, {
          useFlex: true,
          tooltip: false,
          children: buttonText
        })
      });
    }
  }), [isDisabled, buttonUse]);
  const formControlProps = useMemo(() => {
    return {
      'aria-label': (stagePropertyDefinition === null || stagePropertyDefinition === void 0 ? void 0 : stagePropertyDefinition.label) || ''
    };
  }, [stagePropertyDefinition === null || stagePropertyDefinition === void 0 ? void 0 : stagePropertyDefinition.label]);

  // disable when in iframe as modal header can conflict with host app navigation
  if (readOnly || isEmbedded) {
    return /*#__PURE__*/_jsx(StyledSpan, {
      children: stageLabelTranslator({
        label: currentStage.label,
        objectType: ObjectTypeFromIds[objectTypeId] || objectTypeId,
        pipelineId,
        stageId: currentStage.stageId
      })
    });
  }
  const inputComponent = /*#__PURE__*/_jsx(PropertyInputV2, {
    enableAutosave: true,
    getDraftValue: getDraftValue,
    getSavedValue: getSavedValue,
    objectId: `${objectId}`,
    objectTypeId: objectTypeId,
    onChange: handleChange,
    inputProps: inputProps,
    formControlProps: formControlProps,
    disabled: false,
    enableConditionalPropertiesPanel: true,
    enableConditionalPropertyOptions: true,
    showAutoSaveText: true,
    value: value
    // @ts-expect-error Known property issue as they have not updated the type definitions
    // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
    ,
    property: stagePropertyDefinition
  });
  return /*#__PURE__*/_jsx(FieldLevelPermissionTooltip, {
    fieldLevelAccess: fieldLevelAccess,
    children: inputComponent
  });
};
export default /*#__PURE__*/memo(AutosaveChickletStageSelect);